import styles from "./ViewPhoneActivationStatus.module.css";
import { GetPhoneOptionsResponse, PhoneContact } from "../../../lib/api/models";
import classNames from "classnames";
import LabeledInfo from "../../common/LabeledInfo";
import { formatInCentralTime } from "../../../lib/formatting";

const strings = {
  status: "Status: ",
  active: "Active",
  inactive: "Inactive",
  inactivationReason: "Inactivation Reason",
  inactivationDate: "Inactivation Date",
  reactivationDate: "Reactivation Date",
  requestedBy: "Requested By",
  typeOfRequest: "Type of Request",
  none: "None",
  never: "Never",
};

type Props = {
  inactivation: PhoneContact["inactivation"];
  options: GetPhoneOptionsResponse;
  className?: string;
};

export default function ViewPhoneActivationStatus({
  options,
  inactivation,
  className,
}: Props) {
  const inactivationReason =
    inactivation !== null
      ? options.inactivationReasons.find(
          (o) => o.id === inactivation.inactivationReasonId,
        )
      : null;

  const backgroundStyle = inactivation
    ? styles.yellowBackground
    : styles.greenBackground;

  return (
    <div className={classNames(styles.container, className)}>
      <div
        className={classNames(
          styles.statusLine,
          backgroundStyle,
          !inactivation ? styles.activeStatusLine : undefined,
        )}
      >
        <span className={styles.bold}>{strings.status}</span>
        <div
          className={
            inactivation === null ? styles.activeBadge : styles.inactiveBadge
          }
        >
          {inactivation === null ? strings.active : strings.inactive}
        </div>
      </div>

      {inactivation !== null && inactivationReason && (
        <div className={classNames(styles.content, backgroundStyle)}>
          <LabeledInfo
            label={strings.inactivationReason}
            value={inactivationReason.value}
            orientation="vertical"
          />
          <LabeledInfo
            label={strings.inactivationDate}
            value={formatInCentralTime(
              inactivation.inactivationDate,
              "MM/dd/yyyy",
            )}
            orientation="vertical"
          />
          <LabeledInfo
            label={strings.reactivationDate}
            value={
              inactivation.reactivationDate
                ? formatInCentralTime(
                    inactivation.reactivationDate,
                    "MM/dd/yyyy",
                  )
                : strings.never
            }
            orientation="vertical"
          />
          <LabeledInfo
            label={strings.requestedBy}
            value={
              inactivationReason.inactivationSourceTypes.find(
                (o) => o.id === inactivation.inactivationSourceType,
              )?.value ?? strings.none
            }
            orientation="vertical"
          />
          <LabeledInfo
            label={strings.typeOfRequest}
            value={
              inactivationReason.inactivationDeliveryTypes.find(
                (o) => o.id === inactivation.inactivationDeliveryType,
              )?.value ?? strings.none
            }
            orientation="vertical"
          />
        </div>
      )}
    </div>
  );
}
